import React, { useContext } from 'react'
import { AppContext, AppContextType } from './AppContext'
import ElectronIPC from '@/services/ElectronIPC'
import { useViewMode } from '@/pages/SessionPage/internal/shared/useViewMode'
import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'
import { WindowTitleBarBase } from './WindowTitleBarBase'

const MinimizeIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <line x1="5" y1="10.5" x2="15" y2="10.5" stroke="currentColor" strokeWidth="1" />
        </svg>
    )
}

const MaximizeIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <rect x="5.5" y="5.5" width="9" height="9" fill="none" stroke="currentColor" strokeWidth="1" />
        </svg>
    )
}

const CloseIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <line x1="5" y1="5" x2="15" y2="15" stroke="currentColor" strokeWidth="1" />
            <line x1="15" y1="5" x2="5" y2="15" stroke="currentColor" strokeWidth="1" />
        </svg>
    )
}

const buttonClass = 'w-[46px] h-full hover:bg-[#505050] text-[#909090] flex items-center justify-center'

const MainWindowTitleBar: React.FunctionComponent<{}> = () => {
    const { state } = useContext(AppContext) as AppContextType

    const viewMode = useViewMode()

    if (viewMode.fullscreen) {
        return <></>
    }

    return (
        <WindowTitleBarBase windowName="mainWindow">
            {state.windowTitleBar.mainWindowShowMinimize && (
                <Button
                    variant="basic"
                    className={buttonClass}
                    onClick={() => {
                        ElectronIPC.setWindowOptions({ minimize: true })
                    }}
                >
                    <MinimizeIcon />
                </Button>
            )}

            {state.windowTitleBar.mainWindowShowMaximize && (
                <Button
                    variant="basic"
                    className={buttonClass}
                    onClick={() => {
                        ElectronIPC.setWindowOptions({ toggleMaximizeRestore: true })
                    }}
                >
                    <MaximizeIcon />
                </Button>
            )}

            {state.windowTitleBar.mainWindowShowClose && (
                <Button
                    variant="basic"
                    className={cn(buttonClass, 'hover:bg-[#D71526] hover:text-[#ffffff]')}
                    onClick={() => {
                        ElectronIPC.setWindowOptions({ close: true })
                    }}
                >
                    <CloseIcon />
                </Button>
            )}
        </WindowTitleBarBase>
    )
}

export default MainWindowTitleBar
